import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { ROUTES } from 'constants/routes';
import ImageNotFound from 'images/404-assets/not-found.png';
import styled from 'styled-components';

const Container = styled(Box)`
    padding-top: 7.993rem;
    margin: auto;
    width: 28.063rem;
    height: 33.258rem;
    text-align: center;
`;

const MainTitle = styled.h1`
    font-weight: 600;
    size: 1.375rem;
    line-height: 1.664rem;
`;

const SectionDescription = styled.p`
    font-size: 1rem;
    line-height: 1.5rem;
    font-weight: 400;
    margin-bottom: 3.125rem;
`;

const NotFoundImage = styled.img`
    width: 24.614rem;
    height: 16.206rem;
`;

export const PageNotFound = ({ eventId }: { eventId?: number }) => {
    const destination = eventId ? `${ROUTES.EVENT}/${eventId}` : '/';

    return (
        <Container>
            <NotFoundImage src={ImageNotFound} />
            <MainTitle>Page not found!</MainTitle>
            <SectionDescription>
                This page may have been moved or deleted. Please check the URL is correct in the address bar, and get in
                touch with us if you continue to have issues.
            </SectionDescription>
            <Button
                variant="contained"
                size="large"
                endIcon={<ArrowForwardIosIcon />}
                onClick={() => {
                    location.href = destination;
                }}
            >
                Back to Home
            </Button>
        </Container>
    );
};
